import { useState } from 'react'
import Video from './video'

const CatchTheJoy: React.FC = () => {
	const [isVideoPlayerOpen, setIsVideoPlayerOpen] = useState(false)

	return (
		<div className='catch-the-joy--container'>
			<div className='catch-the-joy--player'>
				<div className='btn--video' onClick={() => setIsVideoPlayerOpen(true)}>
					<p>Play video</p>
					<div className='btn--video__icon'>
						<svg width='28' height='28' viewBox='0 0 28 28' fill='none' xmlns='http://www.w3.org/2000/svg'>
							<g clipPath='url(#clip0_112_1258)'>
								<path
									d='M14 2.625C11.7502 2.625 9.551 3.29213 7.68039 4.54203C5.80978 5.79193 4.35182 7.56847 3.49088 9.64698C2.62993 11.7255 2.40467 14.0126 2.84357 16.2192C3.28248 18.4257 4.36584 20.4525 5.95667 22.0433C7.54749 23.6342 9.57432 24.7175 11.7809 25.1564C13.9874 25.5953 16.2745 25.3701 18.353 24.5091C20.4315 23.6482 22.2081 22.1902 23.458 20.3196C24.7079 18.449 25.375 16.2498 25.375 14C25.3692 10.9849 24.1689 8.09502 22.037 5.96305C19.905 3.83107 17.0151 2.63078 14 2.625ZM17.9813 14.7328L12.7313 18.2328C12.5864 18.3224 12.4203 18.3715 12.25 18.375C12.1057 18.3749 11.9634 18.3412 11.8344 18.2766C11.6945 18.2011 11.5778 18.0889 11.4969 17.9521C11.4159 17.8152 11.3738 17.659 11.375 17.5V10.5C11.3738 10.341 11.4159 10.1848 11.4969 10.0479C11.5778 9.91112 11.6945 9.79894 11.8344 9.72344C11.9748 9.65234 12.1314 9.61899 12.2886 9.62666C12.4458 9.63433 12.5984 9.68276 12.7313 9.76719L17.9813 13.2672C18.1031 13.3467 18.2032 13.4554 18.2725 13.5833C18.3418 13.7113 18.3781 13.8545 18.3781 14C18.3781 14.1455 18.3418 14.2887 18.2725 14.4167C18.2032 14.5446 18.1031 14.6533 17.9813 14.7328Z'
									fill='white'
								/>
							</g>
							<defs>
								<clipPath id='clip0_112_1258'>
									<rect width='28' height='28' fill='white' />
								</clipPath>
							</defs>
						</svg>
					</div>
				</div>
				<h3 className='joyyy'>Catch the joy!</h3>
			</div>

			<Video isVideoPlayerOpen={isVideoPlayerOpen} closeModal={() => setIsVideoPlayerOpen(false)} />
		</div>
	)
}

export default CatchTheJoy
